<template>
  <div class="ml">

    <div class="ml-wrapper">

      <!-- ===== SOL: Brand Panel (desktop) ===== -->
      <div class="ml-side">
        <div class="ml-side__inner">
          <div class="ml-side__icon-wrap">
            <i class="icon-feather-lock ml-side__icon"></i>
          </div>
          <h1 class="ml-side__title">{{ $t('forgot_password.header') }}</h1>
          <p class="ml-side__desc">{{ $t('forgot_password.first_error') }}</p>
        </div>
      </div>

      <!-- ===== SAĞ: Form Panel ===== -->
      <div class="ml-main">
        <div class="ml-main__inner">

          <!-- Mobil: başlık üstte -->
          <div class="ml-brand-mobile">
            <div class="ml-brand-mobile__avatar">
              <i class="icon-feather-lock ml-brand-mobile__icon"></i>
            </div>
            <div class="ml-brand-mobile__name">{{ $t('forgot_password.header') }}</div>
          </div>

          <!-- Card -->
          <div class="ml-card">

            <!-- Bilgilendirme -->
            <div class="ml-info">
              <ul class="ml-info__list">
                <li>{{ $t('forgot_password.first_error') }}</li>
                <li>{{ $t('forgot_password.second_error') }}</li>
                <li>{{ $t('forgot_password.third_error') }}</li>
              </ul>
            </div>

            <form @submit.prevent="onSubmit()">

              <!-- Email / Telefon -->
              <div class="ml-group">
                <label class="ml-label">{{ $t('forgot_password.email_telephone') }}</label>
                <div class="ml-input-wrap">
                  <i class="icon-feather-mail ml-input-wrap__pre"></i>
                  <input v-model="username" :disabled="requestSent" class="ml-input" required type="text"/>
                </div>
              </div>

              <!-- Error -->
              <div v-if="errors" class="ml-alert ml-alert--error">
                <i class="uil-exclamation-triangle ml-alert__icon"></i>
                <span class="ml-alert__text">{{ errors }}</span>
              </div>

              <!-- Success -->
              <div v-if="message" class="ml-alert ml-alert--success">
                <i class="uil-check-circle ml-alert__icon"></i>
                <span class="ml-alert__text">{{ message }}</span>
              </div>

              <!-- Actions -->
              <div class="ml-actions">
                <button class="ml-link" type="button" @click="$router.push({ name: 'login' })">
                  <i class="icon-feather-arrow-left"></i> {{ $t('general.back') }}
                </button>
                <button :disabled="submitButtonDisabled || requestSent" class="ml-btn" type="submit">
                  <span v-if="submitButtonDisabled" uk-spinner="ratio: 0.45"></span>
                  <span v-else>{{ $t('forgot_password.send') }}</span>
                </button>
              </div>

            </form>
          </div>

        </div>
      </div>

    </div>

    <!-- Powered by logo -->
    <div class="ml-powered">
      <BrandSignature
        :src="poweredLogo"
        logo-height="20px"
        logo-class="ml-powered__img"
        size="small"
        theme="muted"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { SEND_EMAIL, SET_ERROR } from "@/core/services/store/auth.module";
import { DomainMapper } from "@/core/config/domain-mapper";
import BrandSignature from "@/view/layouts/shared/components/BrandSignature.vue";

export default {
  name: "ForgotPassword",
  components: { BrandSignature },
  data() {
    return {
      username: null,
      phone: null,
      message: null,
      submitButtonDisabled: false,
      requestSent: false,
      company: null,
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    loginLogoFooter() {
      return process.env.BASE_URL + "media/images/logo-dark.svg";
    },
    poweredLogo() {
      if (this.company && this.company.alias === "akademi" && this.company.logo_link) {
        return this.company.logo_link;
      }
      return this.loginLogoFooter;
    },
  },
  methods: {
    async onSubmit() {
      if (this.submitButtonDisabled || this.requestSent) {
        return;
      }

      const username = this.username;
      this.message = null;
      this.$store.commit(SET_ERROR, "");
      this.submitButtonDisabled = true;
      let alias = process.env.VUE_APP_DEFAULT_SUBDOMAIN;

      if (["production", "staging", "develop"].includes(process.env.NODE_ENV)) {
        alias = window.location.hostname.split(".")[0];
        if (["production"].includes(process.env.NODE_ENV) && DomainMapper.hasOwnProperty(window.location.hostname)) {
          alias = DomainMapper[window.location.hostname] || alias;
        }
      }

      try {
        await this.$store.dispatch(SEND_EMAIL, { username, alias });
        this.message = this.$t("messages.reset_link_send");
        this.requestSent = true;
      } catch (_) {
      } finally {
        this.submitButtonDisabled = false;
      }
    },
  },
  mounted() {
    this.$store.commit(SET_ERROR, "");

    try {
      const cached = JSON.parse(localStorage.getItem("app_company_info"));
      if (cached && cached.name) {
        this.company = cached;
      }
    } catch (_) {}
  },
};
</script>

<style scoped>
/* ═══════════════════════════════════════
   FORGOT PASSWORD — Layout shell
   ═══════════════════════════════════════ */
.ml {
  position: fixed;
  inset: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  background: #f7f8fc;
  z-index: 100;
}

.ml-wrapper {
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
}

/* ═══════════════════════════════════════
   SOL PANEL
   ═══════════════════════════════════════ */
.ml-side {
  display: none;
}

.ml-side__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
}

.ml-side__icon-wrap {
  width: 96px;
  height: 96px;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.ml-side__icon {
  font-size: 40px;
  color: #fff;
}

.ml-side__title {
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 8px;
  line-height: 1.3;
  letter-spacing: -0.01em;
}

.ml-side__desc {
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
  line-height: 1.5;
  max-width: 280px;
}

/* ═══════════════════════════════════════
   SAĞ PANEL — Form
   ═══════════════════════════════════════ */
.ml-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 24px 32px;
}

.ml-main__inner {
  width: 100%;
  max-width: 420px;
}

/* ─── Mobil brand ─── */
.ml-brand-mobile {
  text-align: center;
  margin-bottom: 24px;
  padding: 0 8px;
}

.ml-brand-mobile__avatar {
  width: 72px;
  height: 72px;
  margin: 0 auto 14px;
  border-radius: 16px;
  background: #666CFF;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06),
  0 8px 24px rgba(102, 108, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.ml-brand-mobile__icon {
  font-size: 28px;
  color: #fff;
}

.ml-brand-mobile__name {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  line-height: 1.3;
}

/* ═══════════════════════════════════════
   CARD
   ═══════════════════════════════════════ */
.ml-card {
  width: 100%;
  background: #fff;
  border-radius: 14px;
  padding: 24px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04),
  0 4px 16px rgba(0, 0, 0, 0.04);
}

/* ─── Info list ─── */
.ml-info {
  margin-bottom: 20px;
}

.ml-info__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ml-info__list li {
  position: relative;
  padding-left: 18px;
  font-size: 13px;
  color: #6b7280;
  line-height: 1.5;
  margin-bottom: 6px;
}

.ml-info__list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 7px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #d1d5db;
}

.ml-info__list li:last-child {
  margin-bottom: 0;
}

/* ─── Form group ─── */
.ml-group {
  margin-bottom: 18px;
}

.ml-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  line-height: 1;
}

/* ─── Input ─── */
.ml-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.ml-input-wrap__pre {
  position: absolute !important;
  left: 14px !important;
  top: 25% !important;
  font-size: 15px;
  color: #9ca3af;
  pointer-events: none;
  line-height: 1;
  margin: 0 !important;
  padding: 0 !important;
}

.ml-input {
  width: 100%;
  height: 46px;
  padding: 0 14px 0 40px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  font-size: 14px;
  font-family: inherit;
  color: #1f2937;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.ml-input:focus {
  border-color: #666CFF;
  box-shadow: 0 0 0 3px rgba(102, 108, 255, 0.1);
  background: #fff;
}

.ml-input::placeholder {
  color: #b0b5bf;
}

/* ─── Alerts ─── */
.ml-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 10px;
  margin-bottom: 18px;
}

.ml-alert--error {
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.ml-alert--error .ml-alert__icon {
  color: #ef4444;
}

.ml-alert--error .ml-alert__text {
  color: #b91c1c;
}

.ml-alert--success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
}

.ml-alert--success .ml-alert__icon {
  color: #22c55e;
}

.ml-alert--success .ml-alert__text {
  color: #166534;
}

.ml-alert__icon {
  font-size: 15px;
  flex-shrink: 0;
  margin-top: 1px;
}

.ml-alert__text {
  font-size: 13px;
  line-height: 1.45;
}

/* ─── Actions row ─── */
.ml-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 4px;
}

.ml-link {
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: 500;
  color: #666CFF;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  transition: opacity 0.15s ease;
}

.ml-link:hover {
  opacity: 0.8;
}

.ml-link:active {
  opacity: 0.6;
}

.ml-btn {
  height: 44px;
  padding: 0 32px;
  border: none;
  border-radius: 10px;
  background: #666CFF;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
  -webkit-tap-highlight-color: transparent;
}

.ml-btn:hover {
  background: #5a5fe6;
}

.ml-btn:active {
  transform: scale(0.97);
  background: #5258d4;
}

.ml-btn:disabled {
  opacity: 0.6;
  pointer-events: none;
}

/* ─── Powered by ─── */
.ml-powered {
  position: absolute;
  bottom: 16px;
  right: 16px;
  opacity: 0.78;
  transition: opacity 0.2s ease;
}

.ml-powered:hover {
  opacity: 1;
}

.ml-powered__img {
  height: 20px;
  width: auto;
}

/* ═══════════════════════════════════════
   RESPONSIVE
   ═══════════════════════════════════════ */

@media (max-height: 640px) {
  .ml-main {
    padding-top: 24px;
    padding-bottom: 16px;
  }

  .ml-brand-mobile {
    margin-bottom: 20px;
  }

  .ml-brand-mobile__avatar {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    margin-bottom: 10px;
  }

  .ml-brand-mobile__icon {
    font-size: 22px;
  }

  .ml-brand-mobile__name {
    font-size: 16px;
  }

  .ml-group {
    margin-bottom: 14px;
  }

  .ml-card {
    padding: 20px 16px;
  }
}

/* ═══ DESKTOP (>= 960px) ═══ */
@media (min-width: 960px) {
  .ml {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ml-wrapper {
    flex-direction: row;
    max-width: 900px;
    width: 100%;
    min-height: auto;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06),
    0 12px 48px rgba(0, 0, 0, 0.08);
  }

  .ml-side {
    display: flex;
    flex: 1 1 50%;
    min-height: 420px;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #666CFF 0%, #5258d4 50%, #3d42a8 100%);
    position: relative;
    overflow: hidden;
  }

  .ml-side::before,
  .ml-side::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
  }

  .ml-side::before {
    width: 300px;
    height: 300px;
    top: -80px;
    left: -60px;
  }

  .ml-side::after {
    width: 200px;
    height: 200px;
    bottom: -40px;
    right: -40px;
  }

  .ml-side__inner {
    position: relative;
    z-index: 1;
  }

  .ml-main {
    flex: 1 1 50%;
    padding: 40px 36px;
    background: #fff;
  }

  .ml-main__inner {
    max-width: 100%;
  }

  .ml-brand-mobile {
    display: none;
  }

  .ml-card {
    padding: 0;
    border-radius: 0;
    box-shadow: none;
    background: transparent;
  }

  .ml-group {
    margin-bottom: 20px;
  }

  .ml-input {
    height: 48px;
    font-size: 15px;
  }

  .ml-btn {
    height: 46px;
    font-size: 15px;
    padding: 0 36px;
  }

  .ml-label {
    font-size: 14px;
    margin-bottom: 8px;
  }

  .ml-link {
    font-size: 14px;
  }

  .ml-powered {
    bottom: 24px;
    right: 24px;
  }
}

@media (min-width: 1200px) {
  .ml-wrapper {
    max-width: 1000px;
  }

  .ml-side__title {
    font-size: 26px;
  }

  .ml-side__icon-wrap {
    width: 104px;
    height: 104px;
    border-radius: 24px;
    margin-bottom: 28px;
  }

  .ml-side__icon {
    font-size: 44px;
  }

  .ml-main {
    padding: 48px 44px;
  }
}
</style>
